import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import apiService from "../backend/api";

const useProfile = (username) => {
  const queryClient = useQueryClient();

  const query = useQuery({
    queryKey: ["profile", username],
    queryFn: async () => {
      if (!username) return null;
      const data = await apiService.getProfile(username);
      if (data?.error) {
        throw new Error(data.error);
      }
      return data;
    },
    enabled: !!username,
    staleTime: 1000 * 60 * 5, // Data is fresh for 5 minutes
  });

  const updateMutation = useMutation({
    mutationFn: async (profileData) => {
      return apiService.updateProfile(username, profileData);
    },
    onSuccess: (updatedProfile) => {
      queryClient.setQueryData(["profile", username], updatedProfile);
      queryClient.invalidateQueries(["profile", username]);
    },
  });

  return {
    ...query,
    updateProfile: updateMutation.mutate,
    isUpdating: updateMutation.isLoading,
  };
};

export default useProfile;
